import {DebouncedInput} from "./DebouncedInput";
import PropTypes from "prop-types";

export const ColumnFilter = ({
                                 column
                                 //, table // @deprecated
                             }) => {

    const columnFilterValue = column.getFilterValue();

    const {filterVariant} = column.columnDef.meta ?? {}

    const options = column.columnDef?.options || column.columnDef.meta?.options || null;

    // @deprecated
    // return filterVariant === "range" ? (
    //     <div>
    //         <div>
    //             <DebouncedInput
    //                 type="number"
    //                 min={Number(column.getFacetedMinMaxValues()?.[0] ?? "")}
    //                 max={Number(column.getFacetedMinMaxValues()?.[1] ?? "")}
    //                 value={columnFilterValue?.[0] ?? ""}
    //                 onChange={(value) =>
    //                     column.setFilterValue((old) => [value, old?.[1]])
    //                 }
    //                 placeholder="min"
    //             />
    //             <DebouncedInput
    //                 type="number"
    //                 min={Number(column.getFacetedMinMaxValues()?.[0] ?? "")}
    //                 max={Number(column.getFacetedMinMaxValues()?.[1] ?? "")}
    //                 value={columnFilterValue?.[1] ?? ""}
    //                 onChange={(value) =>
    //                     column.setFilterValue((old) => [old?.[0], value])
    //                 }
    //                 placeholder="max"
    //             />
    //         </div>
    //     </div>


    return <>
        <DebouncedInput
            type={filterVariant || 'text'}
            options={options}
            value={columnFilterValue ?? ""}
            onChange={(value) => column.setFilterValue(value)}
            placeholder={`Szukaj...`}
            list={column.id + "list"}
        />
    </>
    // );
}

ColumnFilter.propTypes = {
    column: PropTypes.object.isRequired,
    table: PropTypes.object.isRequired
}